import * as tslib_1 from "tslib";
import React from 'react';
import DeviationGrid from '../DeviationGrid';
import ContainerSize from '../../../ContainerSize';
import { compose } from 'redux';
import SelectableDeviationWrapper from '../../_partials/SelectableDeviationWrapper';
import DeviationDumbView from '../../../DeviationViews/Dumbo';
import withFilter from '../../_hocs/withFilter';
import PollForThumbReady from '../../../DeviationViews/Helper/PollForThumbReady';
import { getDeviationType } from '../../../DeviationViews/_helpers';
import { getIsGif } from '../../../redux/deviations/selectors';
import s from './DeviationSelector.scss';
var enhance = compose(withFilter);
var DeviationSelector = /** @class */ (function (_super) {
    tslib_1.__extends(DeviationSelector, _super);
    function DeviationSelector() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.deviationRenderer = function (deviation) {
            var _a = _this.props, allowedDeviationTypes = _a.allowedDeviationTypes, allowGifs = _a.allowGifs;
            var isSelectionAllowed = true;
            var isGif = getIsGif(deviation);
            if (!allowGifs && isGif) {
                isSelectionAllowed = false;
            }
            var deviationType = getDeviationType(deviation);
            if (allowedDeviationTypes !== undefined &&
                !allowedDeviationTypes.find(function (filter) { return filter === deviationType; })) {
                isSelectionAllowed = false;
            }
            if (!isSelectionAllowed) {
                return (React.createElement(ContainerSize, { className: s['thumb-measured-container'] }, function (_a) {
                    var width = _a.width, height = _a.height;
                    return (React.createElement("div", { style: { opacity: 0.3 } },
                        React.createElement(DeviationDumbView, { deviation: deviation, width: width, height: height })));
                }));
            }
            return (React.createElement(ContainerSize, { className: s['thumb-measured-container'] }, function (_a) {
                var width = _a.width, height = _a.height;
                return (React.createElement(SelectableDeviationWrapper, { key: deviation.deviationId, deviation: deviation },
                    React.createElement(PollForThumbReady, { deviation: deviation },
                        React.createElement(DeviationDumbView, { deviation: deviation, width: width, height: height }))));
            }));
        };
        return _this;
    }
    DeviationSelector.prototype.render = function () {
        var deviations = this.props.deviations;
        return (React.createElement(DeviationGrid, { deviations: deviations, deviationRenderer: this.deviationRenderer }));
    };
    return DeviationSelector;
}(React.Component));
export { DeviationSelector };
export default enhance(DeviationSelector);
//# sourceMappingURL=DeviationSelector.connected.js.map